export const frequentlyAskedQuestions = [
    {
        question: "What is workplacePAY?",
        answer: "workplacePAY automates payroll processing, tax deductions and employee payments while ensuring compliance with local regulations"
    },
    {
        question: "How does workPlacePAY help my business?",
        answer: "It streamlines payroll operations by reducing manual work and eliminating errors"
    },
    {
        question: "Can workPlacePAY handle tax compliance for different sectors?",
        answer: "Absolutely. workPlacePAY is sector-agnostic and built to scale, ensuring your business stays compliant with tax regulations across industries"
    },
    {
        question: "Does workPlacePay handle PAYE reports?",
        answer: "Yes, workPlacePay generates PAYE, pension, general payroll, summary, and variance reports to help you stay compliant and manage payroll with ease"
    },
    {
        question: "How do I run payroll with WorkplacePAY?",
        answer: "To run payroll, select the year and month, click Run Payroll, then choose Proceed to review the employee data and manually process and save the payroll later, or Proceed and Save to process and save the payroll immediately.",
    },

];


